// extracted by mini-css-extract-plugin
module.exports = {"root":"Spinner_root__8EYZG","loader":"Spinner_loader__3aW-D","rotate":"Spinner_rotate__A0CHw","small":"Spinner_small__2O0Ih","medium":"Spinner_medium__28Dhy"};